export default "__VITE_ASSET__DZoO0bLG__"